<div class="operator-container">
  @if (view === 'Measures') {
    <lm-field-picker-period-operator
      [uiFieldSpec]="uiFieldSpec"
      [operatorInfo]="operatorInfo"
      [validPeriods]="validPeriods"
      (operatorChangedEvent)= "onOperatorChange($event)">
    </lm-field-picker-period-operator>
  } @else {
    <lm-field-picker-field-operator #FieldOperatorView
      [uiFieldSpec]="uiFieldSpec"
      [operatorInfo]="operatorInfo"
      [auditData]="auditData"
      (operatorChangedEvent)= "onOperatorChange($event)">
    </lm-field-picker-field-operator>
  }
  <div class="" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
    <div class="field">
      <label soho-label for="lplName">{{ 'FieldPicker_FieldPreviewLabel' | translate }}</label>
      <p data-automation-id="lm-field-picker-operator-preview-name" id="lplName" [ngClass]="{'form-layout-compact': useCompactFormLayout}"><b>{{lplName}}</b></p>
    </div>
    @if (operatorExample) {
      <div class="field">
        <label soho-label for="lplName">{{ 'FieldPicker_OperatorExampleLabel' | translate }}</label>
        <p data-automation-id="lm-field-picker-operator-format-example" id="operatorExample" [ngClass]="{'form-layout-compact': useCompactFormLayout}"><b>{{operatorExample}}</b></p>
      </div>
    }
  </div>
</div>